import { registerOpenModal } from 'src/widgets/embed/openModal'
import { openModal } from 'src/flp/dialogModals'

// FLP-side `share:*` handler. The donate widget on an FLP triggers
// share via openModal({ id: 'share:<external_id>', src, ariaLabel });
// the envelope bubbles up the channel to the FLP, where this handler
// intercepts before the embed-script default (renderModal iframe) can
// run. Opens FLP's own BS5 share modal markup at #shareModal —
// rendered server-side by app/views/fundraiser_landing_pages/_share-modal.html.erb.
//
// The wildcard catches every per-partner_item share id without
// needing to know each one's external_id; the FLP has one share
// modal that's appropriate for the whole fundraiser regardless of
// which donate-widget instance triggered it.
registerOpenModal('share:*', () => {
  if (!document.getElementById('shareModal'))
    throw new Error('No #shareModal element to open')
  openModal('shareModal')
})
